"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CategoryFilter = _interopRequireDefault(require("./CategoryFilter"));
var _SortDescriptor = _interopRequireDefault(require("./SortDescriptor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CategoryQuery model module.
 * @module model/CategoryQuery
 * @version 1.1.3-alpha.1
 */
class CategoryQuery {
  /**
   * Constructs a new <code>CategoryQuery</code>.
   * @alias module:model/CategoryQuery
   */
  constructor() {
    CategoryQuery.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CategoryQuery</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CategoryQuery} obj Optional instance to populate.
   * @return {module:model/CategoryQuery} The populated <code>CategoryQuery</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CategoryQuery();
      if (data.hasOwnProperty('skip')) {
        obj['skip'] = _ApiClient.default.convertToType(data['skip'], 'Number');
      }
      if (data.hasOwnProperty('take')) {
        obj['take'] = _ApiClient.default.convertToType(data['take'], 'Number');
      }
      if (data.hasOwnProperty('sorting')) {
        obj['sorting'] = _ApiClient.default.convertToType(data['sorting'], [_SortDescriptor.default]);
      }
      if (data.hasOwnProperty('filter')) {
        obj['filter'] = _CategoryFilter.default.constructFromObject(data['filter']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CategoryQuery</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryQuery</code>.
   */
  static validateJSON(data) {
    if (data['sorting']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['sorting'])) {
        throw new Error("Expected the field `sorting` to be an array in the JSON data but got " + data['sorting']);
      }
      // validate the optional field `sorting` (array)
      for (const item of data['sorting']) {
        _SortDescriptor.default.validateJSON(item);
      }
      ;
    }
    // validate the optional field `filter`
    if (data['filter']) {
      // data not null
      _CategoryFilter.default.validateJSON(data['filter']);
    }
    return true;
  }
}

/**
 * @member {Number} skip
 */
CategoryQuery.prototype['skip'] = undefined;

/**
 * @member {Number} take
 */
CategoryQuery.prototype['take'] = undefined;

/**
 * @member {Array.<module:model/SortDescriptor>} sorting
 */
CategoryQuery.prototype['sorting'] = undefined;

/**
 * @member {module:model/CategoryFilter} filter
 */
CategoryQuery.prototype['filter'] = undefined;
var _default = exports.default = CategoryQuery;